import { render, staticRenderFns } from "./ring4.vue?vue&type=template&id=3bb81dbe&scoped=true&"
import script from "./ring4.vue?vue&type=script&lang=js&"
export * from "./ring4.vue?vue&type=script&lang=js&"
import style0 from "./ring4.vue?vue&type=style&index=0&id=3bb81dbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb81dbe",
  null
  
)

export default component.exports